import DATATABLE_TRANSLATIONS from "./datatable_translations";

export default class ExtLanguageCourseTimesDataTable {
  constructor() {
    $(document).ready(function () {
      showExtLanguageCourseTimesTable()
    });

    $(document).on("turbo:render", function () {
      showExtLanguageCourseTimesTable()
    });

    function showExtLanguageCourseTimesTable() {
      $('#ext-language-course-time-datatable').dataTable({
        "order": [],
        "columnDefs": [{
          "targets": 'no-sort',
          "orderable": false,
        }],
        "language": DATATABLE_TRANSLATIONS,
        "processing": true,
        "serverSide": true,
        "ajax": {
          "url": $('#ext-language-course-time-datatable').data('source')
        },
        "pagingType": "full_numbers",
        "columns": [
          { "data": "name" },
          { "data": "active" },
          { "data": "actions" }
        ]
        // pagingType is optional, if you want full pagination controls.
        // Check dataTables documentation to learn more about
        // available options.
      });
    }
  }
}
